export const actionTypes = {
  GET_USERS: 'GET_USERS',
  GET_USERS_SUCCESS: 'GET_USERS_SUCCESS',
  CREATE_USER: 'CREATE_USER',
  GET_USER_BY_ID: 'GET_USER_BY_ID',
  UPDATE_USER: 'UPDATE_USER',
};

export const getUsers = (
  data,
  callback = (_res: { message: string; organizations: { id: string; name: string } }, _message: string) => {},
) => ({
  type: actionTypes.GET_USERS,
  payload: data,
  callback,
});

export const getUsersSuccess = data => ({
  type: actionTypes.GET_USERS_SUCCESS,
  payload: data,
});

export const createUser = (data, callback = (_res: { id: string }, _message: string) => {}) => ({
  type: actionTypes.CREATE_USER,
  payload: data,
  callback,
});

export const getUserById = (id: string, callback = (_res: any, _message: string) => {}) => ({
  type: actionTypes.GET_USER_BY_ID,
  callback,
  payload: id,
});

export const updateUser = (data, callback = (_res: { id: string }, _message: string) => {}) => ({
  type: actionTypes.UPDATE_USER,
  payload: data,
  callback,
});
